import classNames from 'classnames';
import React from 'react';

export interface CircularProgressProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  /**
   * 不確定かどうか.
   */
  isIndeterminate?: boolean;
  /**
   * 半径
   */
  radius?: number;
  /**
   * 進捗率(%). 0~100 の数値
   */
  value?: number;
  /**
   * 線の幅
   */
  stroke?: number
  /**
   * 背景を持つかどうか
   */
  hasBackground?: boolean
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  isIndeterminate = false,
  radius = 24,
  value = 35,
  stroke = 4,
  className,
  hasBackground = true,
  ...props
}) => {
  const classes = classNames(
    "uc-progress",
    className,
    isIndeterminate && "uc-progress--indeterminate"
  )
  const size = radius * 2;
  const cx = (size - stroke) / 2;
  const cy = (size - stroke) / 2;
  const r  = (size - stroke) / 2;

  const strokeDasharray = r * 2 * Math.PI;
  const strokeDashOffset = strokeDasharray * (100 - value) / 100

  const indicatorProps = {
    cx,
    cy,
    r,
    style: { transform: `translate(${stroke / 2}px, ${stroke / 2}px)` },
    strokeWidth: stroke,
    strokeDasharray: strokeDasharray,
  };

  return (
    <div className={classes} {...props}>
      <svg
        className="uc-progress__circle"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: size + "px",
          height: size + "px",
        }}
        viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="uc-progress__circle-indicator"
          {...indicatorProps}
          strokeDashoffset={strokeDashOffset} />
        {hasBackground &&
          <circle
            className="uc-progress__circle-background"
            {...indicatorProps} />}
      </svg>
    </div>
  );
};

export default CircularProgress;